import { supabase } from "@/integrations/supabase/client";

export const ACTIVE_WINDOW_DAYS = 14;

export function isActive(lastActiveAt?: string | null): boolean {
  if (!lastActiveAt) return false;
  const last = new Date(lastActiveAt).getTime();
  if (Number.isNaN(last)) return false;
  const cutoff = Date.now() - ACTIVE_WINDOW_DAYS * 24 * 60 * 60 * 1000;
  return last >= cutoff;
}

export function activityLabel(lastActiveAt?: string | null): "Active" | "Inactive" {
  return isActive(lastActiveAt) ? "Active" : "Inactive";
}

/** Fire-and-forget update of the current user's last_active_at. */
export async function touchLastActive(): Promise<void> {
  try {
    await supabase.rpc("touch_last_active");
  } catch {
    // no-op
  }
}
